import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./state/state";

const store = configureStore({
  reducer: {
    auth: authSlice,
  },
});
export default store;
